import { blueprints } from '../blueprints/blueprints-sidecar'
import { cargoes } from '../entities/cargoes-sidecar'
import { monsters } from '../monsters/monsters-sidecar'
import { distance } from '../lib/distance-sidecar'
import { scene } from '../main/scene-sidecar'
import { tileMapShip } from '../tiles/tileMapShip-sidecar'
import { tilesShip } from '../tiles/tilesShip-sidecar'
import { IJob, ITask } from './jobs'
import { jobs } from './jobs-sidecar'
import { jobLogger } from './jobLogger-sidecar'
import { machines } from '../machines/machines-sidecar'
import { stacks } from '../entities/stacks-sidecar'

export function createTask_debuild(i: number, j: number): ITask {
  return jobs._createTask(i, j, 'debuild', {})
}

export function runTask_debuild(job: IJob, task: ITask) {
  jobLogger.assertTaskType(task, 'debuild')
  let m = jobLogger.assertReserved(job)

  // Are we at the right spot?
  if (!distance.isAt(m.i, m.j, task.i, task.j)) {
    return jobLogger.failTask(job, task, 'wrong spot')
  }

  let blueprintHere = blueprints.findAtSpot(m.i, m.j, (c) => true)

  // Blueprint went missing
  if (!blueprintHere) {
    return jobLogger.failTask(job, task, 'lost blueprint')
  }

  blueprints.kill(blueprintHere)

  let mc = machines.findAtSpot(m.i, m.j, (c) => true)
  if (mc) {
    machines.kill(mc)
  }

  let st = stacks.findAtSpot(m.i, m.j, (c) => true)
  if (st) {
    stacks.kill(st)
  }

  let ctx = scene.getContext()
  let car = cargoes.create('steel')
  cargoes.moveToTile(car, ctx.mapShip, m.i, m.j)
  monsters.pickupCargo(m, car)

  jobLogger.succeedTask(job, task)
}
